<div class="bg-white position-sticky pt-3 fixed_btn_on_responsive">
  <button type="submit" class="btn btn-primary w-100 fw-bold" (click)="submit()" [ngClass]="isMobile ? 'py-4 font-24' : 'py-3'" checkFormError [disabled]="isLoading">
    <span class="material-icons-outlined me-1 va-sub" [ngClass]="isMobile ? 'font-24' : 'font-20'" *ngIf="!isLoading">{{ btnIcon }}</span>
    <span *ngIf="isLoading" class="spinner-border spinner-border-sm v-middle me-1"></span>
    {{ btnText | translate }}
  </button>
</div>
